// extracted by mini-css-extract-plugin
export default {"content":"StoryDeleted_content__FdI2c"};